(() => {
  const normalize = (v) =>
    (v || "")
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-");

  function getColorFromVariant(variant) {
    if (!variant) return "";
    return variant.option1 || variant.option2 || variant.option3 || "";
  }

  function filterGallery(gallery, colorHandle) {
    if (!gallery) return;

    gallery.setAttribute("data-filtering", "true");

    const slides = Array.from(
      gallery.querySelectorAll("slideshow-slide")
    );

    const gridItems = Array.from(
      gallery.querySelectorAll(".media-gallery__grid li")
    );

    const matches = (alt) => {
      const a = normalize(alt);
      if (!a) return true;
      if (!colorHandle) return true;
      return a.includes(colorHandle);
    };

    // 🔹 Mobile slideshow (SEM display:none)
    slides.forEach(slide => {
      const img = slide.querySelector("img[alt]");
      const alt = img?.alt || "";
      if (matches(alt)) {
        slide.removeAttribute("hidden");
      } else {
        slide.setAttribute("hidden", "");
      }
    });

    // 🔹 Desktop grid (pode usar display:none)
    gridItems.forEach(li => {
      const img = li.querySelector("img[alt]");
      const alt = img?.alt || "";
      li.style.display = matches(alt) ? "" : "none";
    });

    // 🔹 Garante que o slideshow não fique preso em slide oculto
    const firstVisible = slides.find(s => !s.hasAttribute("hidden"));
    if (firstVisible) {
      requestAnimationFrame(() => {
        window.dispatchEvent(new Event("resize"));
      });
    }

    requestAnimationFrame(() => {
      gallery.removeAttribute("data-filtering");
    });
  }

  // ✅ Evento NATIVO do Fabric
  document.addEventListener("variant:update", (e) => {
    const variant = e.detail?.variant;
    if (!variant) return;

    const colorHandle = normalize(getColorFromVariant(variant));
    const gallery = document.querySelector("media-gallery");

    filterGallery(gallery, colorHandle);
  });

  // ✅ Inicial
  window.addEventListener("DOMContentLoaded", () => {
    const picker = document.querySelector("variant-picker");
    if (!picker?.variant) return;

    const colorHandle = normalize(getColorFromVariant(picker.variant));
    const gallery = document.querySelector("media-gallery");

    filterGallery(gallery, colorHandle);
  });
})();
